import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const ConfirmationDialog = ({
  open,
  onClose,
  title,
  message,
  actions,
  maxWidth = "sm",
  fullWidth = true,
  paperSx,
  titleSx,
  contentSx,
  actionsSx,
}) => {
  const content =
    typeof message === "string" ? (
      <Typography sx={{ color: "var(--theme-color)" }}>{message}</Typography>
    ) : (
      message
    );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      PaperProps={{
        sx: {
          backgroundColor: "var(--theme-btn-clr)",
          border: "1px solid var(--theme-color)",
          ...paperSx,
        },
      }}
    >
      {title ? (
        <DialogTitle
          sx={{
            color: "var(--theme-color)",
            fontWeight: 700,
            borderBottom: "1px solid var(--theme-color)",
            ...titleSx,
          }}
        >
          {title}
        </DialogTitle>
      ) : null}
      <DialogContent
        sx={{
          backgroundColor: "var(--theme-bg-header)",
          ...contentSx,
        }}
      >
        {content}
      </DialogContent>
      <DialogActions sx={{ gap: 1, ...actionsSx }}>
        {actions?.map((action, index) => (
          <span key={action.key || action.label || index}>{action.element}</span>
        ))}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
